import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CartIcon, Icon, Typography } from '@klickly/front-packages';
import { inject, observer } from 'mobx-react';
import { ROUTE_PATHS } from '../../../../constants';

const CartData = inject('store')(
    observer(({ store }) => {
        const { closePDP } = store.pdpStore;
        const { getShoppingCartState, amount } = store.shoppingCartStore;
        const navigate = useNavigate();
        const { pathname } = useLocation();

        const onClick = () => {
            closePDP();
            getShoppingCartState();
            navigate(ROUTE_PATHS.shoppingCart());
        };

        return (
            <Typography.Text
                color={pathname.includes(ROUTE_PATHS.shoppingCart()) ? 'primary' : 'primaryText'}
                style={{ cursor: 'pointer' }}
                onClick={onClick}
            >
                <Icon component={() => <CartIcon />} />
                &nbsp;
                <Typography.Text type='badgeMedium' as='span' data-e2e='header-cart-amount'>
                    {amount}
                </Typography.Text>
            </Typography.Text>
        );
    })
);

export default CartData;
